import * as React from 'react'
import { ReactElement } from 'react'
import { useFormikContext } from 'formik'
import { DateTime } from 'luxon'
import ReportForm from './ReportForm'
import { DocumentGenerationType } from '../../../../hooks/document/documentGenerationTypes'
import { ReportFormType } from '../../../../pages/Finance/Reports'
import LocalDatePicker, { LocalDatePickerProps } from '../../../DatePicker/LocalDatePicker'
import FormikField from '../../../Formik/FormikField'

export type InvoiceReportDto = {
    from: string
}

function ReportBody(props: ReportFormType): ReactElement {
    const { values, setFieldValue } = useFormikContext<InvoiceReportDto>()
    return (
        <>
            <FormikField<LocalDatePickerProps, InvoiceReportDto>
                required
                orientation={props.orientation}
                labelKey="base.from"
                fieldName={'from'}
                component={LocalDatePicker}
                componentProps={{
                    isoValue: values.from,
                    onSelectDate: date => setFieldValue('to', date),
                    maxDate: new Date(),
                }}
            />
        </>
    )
}

export default function InvoiceReportForm(props: ReportFormType): ReactElement {
    return (
        <ReportForm<InvoiceReportDto>
            title="Inboeken uitgaande facturen"
            generationType={DocumentGenerationType.CostCentre}
            initialValues={{
                from: DateTime.local().minus({ months: 12 }).startOf('month').toISODate(),
            }}
            {...props}
        >
            <ReportBody {...props} />
        </ReportForm>
    )
}
